import React, { createContext, useState, useEffect } from 'react';
import { supabase } from './services/supabaseClient';
import { setAuthToken } from './store/authToken';

// Expone el access_token de la sesión Supabase y lo empuja al holder de módulo
// (src/store/authToken) que usa el baseQuery de RTK para reenviarlo al proxy.
export const TokenContext = createContext();

export const TokenProvider = ({ children }) => {
  const [accessToken, setAccessToken] = useState(null);

  useEffect(() => {
    let mounted = true;
    const apply = (session) => {
      if (!mounted) return;
      const token = session?.access_token ?? null;
      setAccessToken(token);
      setAuthToken(token); // null en logout -> el holder queda vacío
    };

    // Sesión inicial (incluye la que Supabase parsea del hash del magic link).
    supabase.auth.getSession().then(({ data }) => apply(data?.session));

    // Login / logout / refresh de token.
    const { data: sub } = supabase.auth.onAuthStateChange((_event, session) =>
      apply(session)
    );

    return () => {
      mounted = false;
      sub?.subscription?.unsubscribe();
    };
  }, []);

  return (
    <TokenContext.Provider value={{ accessToken }}>
      {children}
    </TokenContext.Provider>
  );
};
